import {
  Card,
  formatNumber,
  Grid,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import type { InvoiceReportEmployee } from '@omnipresentgroup/types';

type Props = {
  employee: InvoiceReportEmployee;
};

export const InvoiceReportEmployeeBillingSummary = ({ employee }: Props) => (
  <Card>
    <Grid m="24" minItemWidth={100}>
      <Stack gap="8">
        <Typography as="span" size="12" color="subtle" weight="medium">
          Billed total
        </Typography>
        <Typography as="span" size="16" weight="medium">
          {employee.billedAmount
            ? formatNumber({
                input: Number(employee.billedAmount.amount),
                currency: employee.billedAmount.currency,
              })
            : '-'}
        </Typography>
      </Stack>
      <Stack gap="8">
        <Typography as="span" size="12" color="subtle" weight="medium">
          Total billed (excl. fees)
        </Typography>
        <Typography as="span" size="16" weight="medium">
          {employee.billedAmountExcludingFees
            ? formatNumber({
                input: Number(employee.billedAmountExcludingFees.amount),
                currency: employee.billedAmountExcludingFees.currency,
              })
            : '-'}
        </Typography>
      </Stack>
      <Stack gap="8">
        <Typography as="span" size="12" color="subtle" weight="medium">
          Total billed local (excl. fees)
        </Typography>
        <Typography as="span" size="16" weight="medium">
          {employee.localAmountExcludingFees
            ? formatNumber({
                input: Number(employee.localAmountExcludingFees.amount),
                currency: employee.localAmountExcludingFees.currency,
              })
            : '-'}
        </Typography>
      </Stack>
    </Grid>
  </Card>
);
